import Model from "./base/model";

class ChatRoom extends Model{
  resourceName() {
    return "chat_rooms";
  }

  fields() {
    return {
      active: "",
    }
  }
}

export default new ChatRoom();
